import { render, staticRenderFns } from "./sm-interval-button.vue?vue&type=template&id=54877ceb&"
import script from "./sm-interval-button.vue?vue&type=script&lang=js&"
export * from "./sm-interval-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports